import React from 'react';
import { EntityId } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";

import { Spin } from "antd";
import Pagination from '../../../../componets/Pagination';
import Edit from "../Edit";
import GroupUpload from "../../../../componets/FileDropzone/GroupUpload";
import stickerMakerApi from "../../../../api/stickerMakerApi";

import { uploadSticker } from "../../../../actions/sticker_maker/stickersActions";
import ListGrid from "./_ListGrid";
import ListTable from "./_ListTable";

interface propsInterface {
  limit: number;
  stickerPackId?: EntityId;
  type?: 'list' | 'grid';
}

const _List = ({ limit, stickerPackId, type = 'grid' }: propsInterface) => {
  const dispatch  = useAppDispatch();
  const count     = useAppSelector(state => state.stickerMaker.stickers.count);
  const error     = useAppSelector(state => state.stickerMaker.stickers.error);
  const status    = useAppSelector(state => state.stickerMaker.stickers.status);

  function handleUploadSuccess(response: any) {
    dispatch(uploadSticker(response));
  }

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  return (
    <>
      {
        stickerPackId &&
        <GroupUpload
          className='v-mb-10'
          name='image'
          action={stickerMakerApi.oneSky.url('/onesky/stickers')}
          headers={stickerMakerApi.oneSky.uploadHeaders}
          data={{ sticker_pack_id: stickerPackId }}
          onSuccess={handleUploadSuccess}
        />
      }

      { type === 'grid' && <ListGrid /> }
      { type === 'list' && <ListTable className='v-mb-15' /> }

      {<Pagination total={count} size={limit} />}

      <Edit />
    </>
  );
}

export default _List;
